export enum AdvertFilterValueTypeEnum {
  Currency,
  Date,
  Decimal,
}
